<template>
  <div :class="brandClasses.reviewsSearchWrapper">
    <p v-if="reviewsCount" :class="brandClasses.reviewsCount">
      {{ replaceAll($pluralize($t.reviewedByCustomers, reviewsCount), { count: reviewsCount }) }}
    </p>
    <div v-if="$feature.showReviewSearchOnPDP">
      <vf-search-bar
        v-model="searchValue"
        :class-form="brandClasses.reviewsSearchForm"
        :class-input="brandClasses.reviewsSearchInput"
        :class-submit="brandClasses.reviewsSearchSubmit"
        :label="$t.searchReviews"
        :maxlength="200"
        :placeholder="`${$t.searchReviews}...`"
        submit-position="end"
        @clear="clear"
        @submit="emit('search')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { IconSizes } from '#types/sizes'

defineProps<{
  iconSize: IconSizes
  reviewsCount: number
}>()

const emit = defineEmits<{
  'search': []
  'update:model-value': [value: string]
}>()

const searchValue = defineModel<string>()

const { brandClasses } = useAppConfig().pages.pdp

const clear = async () => {
  await nextTick
  emit('search')
}
</script>
